import { PostOrPage } from '@tryghost/content-api';
import axios from 'axios';

const BLOG_HOST = 'https://blog.jhattse.com';
const CONTENT_KEY = '200b73e6edac4d0ebf98b1f226';

export const getCompanyBlogs = async (
  page: number = 1,
  limit: number = 10,
) => {
  const response = await axios.get(`${BLOG_HOST}/ghost/api/content/posts/?key=${CONTENT_KEY}${limit && `&limit=${limit}`}${page && `&page=${page}`}&filter=tag:story&include=tags,authors`);
  return response.data;
}

export const getBrandBlogs = async (
  page: number = 1,
  limit: number = 10,
  tags: string[] = []
) => {
  const response = await axios.get(`${BLOG_HOST}/ghost/api/content/posts/?key=${CONTENT_KEY}${limit && `&limit=${limit}`}${page && `&page=${page}`}${tags && `&filter=${encodeURIComponent(tags.map((t) => 'tags:' + t).join('+'))}`}&include=tags,authors`);
  return response.data;
}

export const getBlogDetails = async (slug: string) => {
  const response = await axios.get(`${BLOG_HOST}/ghost/api/content/posts/slug/${slug}/?key=${CONTENT_KEY}&include=tags,authors`);
  return response.data;
}
